const BROADCAST_STATUS = {
    STOPPED: 'stopped',
    STARTED: 'started',
    RESUMED: 'resumed',
    PAUSED: 'paused',
};

export default BROADCAST_STATUS;